// SIDEBAR NAV (GSAP)
//
//
//
//
//
//
export function initSidebarNav() {

// search sidebar nav
const $siteNavSidebar = document.querySelector('.meta-nav-sidebar');
// only activate if sidebar nav is found
if ($siteNavSidebar) {

  let vdrops = document.querySelectorAll(".vdrop");

  vdrops.forEach(vdrop => {
    const toggle = vdrop.querySelector('.vdrop-btn');
    const menu = vdrop.querySelector('.vdrop-list');
    const menuItems = menu.querySelectorAll('.navlink-sidebar');
    const dropicon = vdrop.querySelector('.metadrop-icon');

    // Pre-calculate menu height
    const menuHeight = menu.scrollHeight;
    menu.style.height = '0px'; // Initial height
    menu.style.overflow = 'hidden';
    menu.style.opacity = '0'; // Start hidden
    dropicon.style.transition = 'transform 0.3s ease-out';

    // Function to open the menu using GSAP
    function openMenu() {
      gsap.to(menu, {
        height: menuHeight,
        opacity: 1,
        marginTop: '0.5rem',
        duration: 0.3,
        ease: 'ease.out'
      });
      toggle.setAttribute('aria-expanded', 'true');
      menu.setAttribute('aria-hidden', 'false');
      menu.style.display = 'flex'; // Ensure the menu remains in the flow
      menuItems[0]?.focus(); // Focus the first item after opening
      gsap.to(dropicon, { rotation: 180, duration: 0.3, ease: 'ease.out' });
    }

    // Function to close the menu using GSAP
    function closeMenu() {
      gsap.to(menu, {
        height: 0,
        opacity: 0,
        marginTop: 0,
        duration: 0.3,
        ease: 'ease.out'
      });
      toggle.setAttribute('aria-expanded', 'false');
      menu.setAttribute('aria-hidden', 'true');
      gsap.to(dropicon, { rotation: 0, duration: 0.3, ease: 'ease.out' });
    }

    // Toggle menu on button click
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      if (menu.style.height === '0px' || menu.style.height === '') {
        openMenu();
      } else {
        closeMenu();
        toggle.focus(); // Return focus to toggle after closing
      }
    });

    // Keyboard navigation for toggle
    toggle.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (menu.style.height === '0px' || menu.style.height === '') {
          openMenu();
        } else {
          closeMenu();
          toggle.focus();
        }
      }
    });

    // Keyboard navigation within the menu
    menu.addEventListener('keydown', (e) => {
      const index = Array.from(menuItems).indexOf(document.activeElement);
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        const nextIndex = (index + 1) % menuItems.length;
        menuItems[nextIndex].focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        const prevIndex = (index - 1 + menuItems.length) % menuItems.length;
        menuItems[prevIndex].focus();
      } else if (e.key === 'Escape') {
        e.preventDefault();
        closeMenu();
        toggle.focus(); // Return focus to toggle on escape
      }
    });

    // Close the menu when clicking outside
    document.addEventListener('click', (event) => {
      if (!vdrop.contains(event.target)) {
        closeMenu();
      }
    });
  });

  //////////// MOBILE SIDEBAR (Updated)

// Only initialize mobile sidebar if hamburger element exists
const hamburger = document.querySelector(".meta-nav-sidebar-hamburger");
if (hamburger) {
  const sidebar = document.querySelector(".meta-nav-sidebar");
  let isSidebarOpen = false;

  // Function to open sidebar using GSAP
  const openSidebar = () => {
    isSidebarOpen = true;
    gsap.to(sidebar, {
      x: '0%', // Slide the sidebar in
      duration: 0.3,
      ease: 'ease.out'
    });
    hamburger.classList.add("active");
    hamburger.setAttribute('aria-expanded', 'true');
    lockScroll();
    
    // Pass the sidebar element directly to prevent scroll outside
    preventScrollOutside(".meta-nav-sidebar");
  };

  // Function to close sidebar using GSAP
  const closeSidebar = () => {
    isSidebarOpen = false;
    gsap.to(sidebar, {
      x: '-110%', // Slide the sidebar out
      duration: 0.3,
      ease: 'ease.out'
    });
    hamburger.classList.remove("active");
    hamburger.setAttribute('aria-expanded', 'false');
    unlockScroll();
    removeScrollPrevention();
    // Ensure scroll is unlocked and scroll prevention is removed
    
  };

  const handleResize = () => {
    if (window.innerWidth >= 991) {
      // Desktop breakpoint: ensure sidebar is visible
      gsap.set(sidebar, { x: '0%' });
      if (isSidebarOpen) {
        isSidebarOpen = false; // Reset state
        unlockScroll();        // Unlock only if it was previously locked
        removeScrollPrevention();
      }
    } else if (!isSidebarOpen) {
      // Mobile breakpoint: ensure sidebar is hidden
      gsap.set(sidebar, { x: '-110%' });
    }
  };

  // Toggle sidebar on hamburger click
  hamburger.addEventListener("click", () => {
    if (isSidebarOpen) {
      closeSidebar();
    } else {
      openSidebar();
    }
  });

  // Close sidebar when clicking outside
  document.addEventListener("click", (event) => {
    const isClickInsideSidebar = sidebar.contains(event.target);
    const isClickOnHamburger = hamburger.contains(event.target);
    if (isSidebarOpen && !isClickInsideSidebar && !isClickOnHamburger) {
      closeSidebar();
    }
  });

  // Listen for resize events
  window.addEventListener("resize", handleResize);

  // Call handleResize on page load to ensure correct state
  handleResize();
}

} // end only activate if sidebar nav is found

} // end module
